import React, { useEffect, useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import './chr-tab.css';
import clsx from 'clsx';

const ChrTab = ({
  defaultActiveKey, activeKey, tabNames, onTabSelect, children, newUx = true
}) => {
  // Tab component doesn't provide any props to remove the tabindex attribute.
  // The tabindex attribute should be removed to provide the keyboard navigation.
  const [selectedTab, setSelectedTab] = useState("");
  const formattedKeyOriginalKeyMap = {};

  const isControlled = activeKey !== undefined;

  const handleSelect = tab => {
    setSelectedTab(tab);
    onTabSelect(formattedKeyOriginalKeyMap[tab]);
  }

  const handleKeyDown = event => {
    if(event.key === 'Enter')
      onTabSelect(event.target.innerHTML);
  }

  useEffect(() => {
    removeTabIndexAttribute()
  }, [selectedTab]);

  const removeTabIndexAttribute = () => {
    const tabElements = document.querySelectorAll(".cui-chr-tab .nav.nav-tabs a");
    tabElements.forEach(tabElement => tabElement.removeAttribute('tabindex'));
  }

  const isSingleTab = () => {
    return tabNames.length === 1;
  }

  const formatKey = key => {
    const formattedKey = key.toLowerCase().replace(/ /g, "_");
    formattedKeyOriginalKeyMap[formattedKey] = key;
    return formattedKey;
  }

  return (
    <>
      {
        isSingleTab() ?
        children(tabNames[0]) :
        <Tabs
          id='chr-tab'
          className='cui-chr-tab'
          {...(isControlled
            ? { activeKey: formatKey(activeKey) }
            : { defaultActiveKey: formatKey(defaultActiveKey) }
          )}
          onSelect={ handleSelect }
          onKeyDown={ handleKeyDown }
          animation={ false }
        >
          {
            tabNames.map(tabName => (
              <Tab eventKey={ formatKey(tabName) } title={ tabName } key={ tabName } tabClassName={ clsx({'font-14 mr-4': !newUx}) }>
                { children(tabName) }
              </Tab>
            ))
          }
        </Tabs>
      }
    </>
  )
}

export default ChrTab;